import {connect} from 'react-redux';
import {get} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import {
  getProfile,
  getRefreshedProfile,
  resetAllCandidatesInfo,
} from '/redux/action/candidate.action';
import {AllCandidatesReduxKeys, resetReport} from '/redux/action/report.action';
import {
  candidateById,
  candidateNameById,
  hasProfileById,
  statusById,
} from '/redux/selector/candidate.selector';
import {paidAsRankDescLastMonth} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {allReportData} from '/redux/selector/report.selector';
import {getDateUtilDefaultInstance} from '/util/date.util';
import {fromProps, withProps} from '/util/selector.util';

import {ReferralProfile} from './ReferralProfile';

const withReferralId = withProps({
  candidateId: fromProps(get('recordId')),
});

const expirationIdentifier = (receivedDate: string): boolean => {
  try {
    const dateUtil = getDateUtilDefaultInstance();
    const parsed = dateUtil.parseEasternDate(receivedDate);
    if (!parsed || isNaN(parsed.getTime())) {
      return true;
    }
    return Date.now() > parsed.getTime();
  } catch (err) {
    return true;
  }
};

export default connect(
  createStructuredSelector({
    featureFlag: variablesFeatureFlag,
    hasProfile: withReferralId(hasProfileById),
    candidateData: withReferralId(candidateById),
    status: withReferralId(statusById),
    candidateName: withReferralId(candidateNameById),
    allReportData,
    userId,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
  }),

  dispatch => ({
    getProfile: ({candidateId}: any) =>
      dispatch<any>(getProfile({candidateId})),
    getRefreshedProfile: ({candidateId}: any) =>
      dispatch<any>(getRefreshedProfile({candidateId})),
    resetReport: ({reportKey}: any) =>
      dispatch<any>(resetReport({reportKey, data: null})),
    resetAllCandidatesInfo: () =>
      dispatch<any>(resetAllCandidatesInfo({inputPayload: null})),
  }),

  (stateProps, dispatchProps, ownProps) => {
    const {hasProfile, candidateData} = stateProps;
    const {recordId: candidateId} = ownProps;
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      hasData: hasProfile,
      hasCandidateData: candidateData && Object.keys(candidateData).length > 0,
      isDateExpired: expirationIdentifier(candidateData?.expirationTime),
      fetchData: () => {
        return dispatchProps.getProfile({candidateId});
      },
      resetCachedMetrics: () => {
        return dispatchProps.getRefreshedProfile({candidateId});
      },
      resetCandidatesData: () => {
        dispatchProps.resetAllCandidatesInfo();
        AllCandidatesReduxKeys.forEach((element: any) => {
          dispatchProps.resetReport({
            reportKey: element,
          });
        });
      },
    };
  },
)(ReferralProfile);
